import * as Sentry from '@sentry/nextjs';

export const logSentryException = ({
  message,
  place,
  data = {},
}: {
  message: string;
  place: string;
  data?: Record<string, any>;
}) => {
  Sentry.captureException(message, {
    extra: { place, ...data },
  });
};
